import { render } from "./ImageGroupSelector.vue?vue&type=template&id=7b01de1c&scoped=true"
import script from "./ImageGroupSelector.vue?vue&type=script&lang=js"
export * from "./ImageGroupSelector.vue?vue&type=script&lang=js"

import "./ImageGroupSelector.vue?vue&type=style&index=0&id=7b01de1c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b01de1c"]])

export default __exports__